/**
 * paid-path gate (extracted from useNoiseFilter for regression cover).
 *
 * LiveKit Cloud bills the Krisp processor as metered voice isolation
 * ($0.0012/min per the LiveKit Enterprise order form). The product decision
 * is NO paid noise cancellation: only hosts on a LiveKit Cloud server may
 * ever reach the Krisp path. Students use the local RNNoise WASM filter on
 * every provider — it runs entirely in the browser and bills nothing.
 */

/** True only for LiveKit Cloud server URLs (wss://…*.livekit.cloud/.run). */
export function isLiveKitCloudServer(serverUrl: string): boolean {
  try {
    const hostname = new URL(serverUrl).hostname.toLowerCase()
    return hostname.endsWith('.livekit.cloud') || hostname.endsWith('.livekit.run')
  } catch {
    return false
  }
}

/** The single gate that decides whether the Krisp (paid) path is reachable. */
export function krispAllowed(opts: { isHost: boolean; serverUrl: string }): boolean {
  return opts.isHost && isLiveKitCloudServer(opts.serverUrl)
}
